import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";

export default function CallModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  customerData, // 🆕 รองรับ prop อีกแบบ
}) {
  const [callForm, setCallForm] = useState({
    Call_Id: "",
    AR_Id: "",
    ServiceAddr_Id: "",
    Comp_Id: "",
    Call_Result: "",
    Call_Remark: "",
  });

  //  รวมทุกแหล่งข้อมูลเข้าด้วยกัน
  const sourceData = initialData || customerData || {};

  //  โหลดค่าเริ่มต้นเมื่อเปิด Modal
    useEffect(() => {
    if (isOpen && (initialData || customerData)) {
      const src = initialData || customerData;
      setCallForm({
        Call_Id: src.Call_Id || "",
        AR_Id: src.AR_Id || "",
        ServiceAddr_Id: src.ServiceAddr_Id || "",
        Comp_Id: src.Comp_Id || "",
        Call_Result: src.Call_Result || "",
        Call_Remark: src.Call_Remark || "",
      });
    }
  }, [isOpen, initialData, customerData]);

  


  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!callForm.Call_Result?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "กรุณากรอกผลการโทร",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const now = new Date();
    const tzOffset = 7 * 60; // GMT+7
    const local = new Date(now.getTime() + tzOffset * 60 * 1000);

    const payload = {
      Call_Id: callForm.Call_Id || null,
      AR_Id: customerData?.AR_Id,
      Comp_Id: customerData?.Comp_Id,
      ServiceAddr_Id: customerData?.ServiceAddr_Id || null,
      Call_Date: local.toISOString().replace("Z", "+07:00"),
      Call_Result: callForm.Call_Result?.trim() || "",
      Call_Remark: callForm.Call_Remark?.trim() || "",
      Call_Type: 1,
    };

    try {
      const mode = sourceData?.mode || (payload.Call_Id ? "edit" : "create");
      const id = payload.Call_Id || null;


      await onSave?.(mode, payload, id);

      await new Promise((r) => setTimeout(r, 1));

      // await Swal.fire({
      //   icon: "success",
      //   title: "สำเร็จ!",
      //   timer: 1500,
      //   showConfirmButton: false,
      // }).then(() => {
        onClose();
      // });

    } catch (err) {
      console.error("Save Call Error:", err);
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกข้อมูลได้", "error");
    }
  };




  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[2000]">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-8 relative max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-2 mb-6">
          <div className="flex items-center gap-2 text-red-500 font-semibold border-b-2 border-red-500 pb-1 whitespace-nowrap">
            <Icon icon="mdi:phone" className="w-5 h-5" />
            บันทึกผลการโทร
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            ✕
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/*  ผลการโทร */}
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 whitespace-nowrap">
              ผลการโทร <span className="text-red-500">*</span>
            </label>
            <textarea
              rows="4"
              value={callForm.Call_Result || ""}
              onChange={(e) =>
                setCallForm({ ...callForm, Call_Result: e.target.value })
              }
              placeholder="เช่น ติดต่อได้ / ปิดการขายได้ / ไม่รับสาย ฯลฯ"
              className="w-full border rounded px-3 py-2 focus:ring focus:ring-red-100"
            />
          </div>

          {/*  หมายเหตุเพิ่มเติม */}
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 whitespace-nowrap">
              หมายเหตุเพิ่มเติม
            </label>
            <textarea
              rows="4"
              value={callForm.Call_Remark || ""}
              onChange={(e) =>
                setCallForm({ ...callForm, Call_Remark: e.target.value })
              }
              placeholder="เช่น นัดโทรอีกครั้งวันศุกร์นี้..."
              className="w-full border rounded px-3 py-2 focus:ring focus:ring-red-100"
            />
          </div>

          {/* ปุ่ม */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="border border-red-400 text-red-500 px-6 py-2 rounded-lg hover:bg-red-50"
            >
              ยกเลิก
            </button>
            <button
              type="submit"
              className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg"
            >
              บันทึก
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
